export class Ambience {
    constructor() {
        this.ctx = null;
        this.master = null;
        this.running = false;
        this.cricketTimer = 0;
    }

    start() {
        if (!this.ctx) {
            const AC = window.AudioContext || window.webkitAudioContext;
            if (!AC) return false;
            this.ctx = new AC();
            this.master = this.ctx.createGain();
            this.master.gain.value = 0;
            this.master.connect(this.ctx.destination);

            // wind: looped brown noise through a slow lowpass
            const len = this.ctx.sampleRate * 2;
            const buf = this.ctx.createBuffer(1, len, this.ctx.sampleRate);
            const data = buf.getChannelData(0);
            let last = 0;
            for (let i = 0; i < len; i++) {
                const w = Math.random() * 2 - 1;
                last = (last + 0.02 * w) / 1.02;
                data[i] = last * 3.5;
            }
            const src = this.ctx.createBufferSource();
            src.buffer = buf;
            src.loop = true;
            const lp = this.ctx.createBiquadFilter();
            lp.type = "lowpass";
            lp.frequency.value = 420;
            const windGain = this.ctx.createGain();
            windGain.gain.value = 0.5;
            src.connect(lp);
            lp.connect(windGain);
            windGain.connect(this.master);
            src.start();

            // slow wind swells
            const lfo = this.ctx.createOscillator();
            lfo.frequency.value = 0.07;
            const lfoGain = this.ctx.createGain();
            lfoGain.gain.value = 0.25;
            lfo.connect(lfoGain);
            lfoGain.connect(windGain.gain);
            lfo.start();

            this.cricketTimer = setInterval(() => this.chirp(), 750);
        }
        this.ctx.resume();
        this.running = true;
        this.master.gain.setTargetAtTime(0.13, this.ctx.currentTime, 0.8);
        return true;
    }

    chirp() {
        if (!this.running || Math.random() < 0.45) return;
        const t0 = this.ctx.currentTime;
        const osc = this.ctx.createOscillator();
        osc.type = "sine";
        osc.frequency.value = 4100 + Math.random() * 800;
        const g = this.ctx.createGain();
        g.gain.value = 0;
        osc.connect(g);
        if (this.ctx.createStereoPanner) {
            const pan = this.ctx.createStereoPanner();
            pan.pan.value = Math.random() * 1.6 - 0.8;
            g.connect(pan);
            pan.connect(this.master);
        } else {
            g.connect(this.master);
        }
        for (let i = 0; i < 3; i++) {
            const t = t0 + i * 0.09;
            g.gain.setValueAtTime(0, t);
            g.gain.linearRampToValueAtTime(0.05, t + 0.02);
            g.gain.linearRampToValueAtTime(0, t + 0.07);
        }
        osc.start(t0);
        osc.stop(t0 + 0.5);
    }

    stop() {
        this.running = false;
        if (this.ctx) {
            this.master.gain.setTargetAtTime(0, this.ctx.currentTime, 0.4);
        }
        clearInterval(this.cricketTimer);
    }
}
